"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var red_1 = require("@material-ui/core/colors/red");
var createStyles_1 = require("@material-ui/styles/createStyles");
exports.default = (function (theme) {
    var inputBase = {
        width: '100%',
    };
    return createStyles_1.default({
        topGridItem: {
            width: 280,
            paddingBottom: theme.spacing() * 4,
            justifyContent: 'space-between'
        },
        requiredFieldNotice: {
            paddingBottom: theme.spacing() * 2,
        },
        fullWidth: {
            width: '100%'
        },
        halfWidth: {
            width: '100%'
        },
        twoByChild: {
            width: '48%'
        },
        primaryInput: inputBase,
        errorInput: Object.assign({}, inputBase, {
            'backgroundColor': red_1.default[50],
            '&::before': {
                borderColor: red_1.default[500]
            }
        }),
        errorSnackbar: {
            backgroundColor: theme.palette.error.dark
        }
    });
});
